
//-----------------------|| securities MENU ITEMS ||-----------------------//
export const jd = {
    id: '',
    title: '',
    type: 'group',
    children: [
        {
            id: 'masters.view_tbljobdescription',
            title: 'Job Description',
            type: 'item',
            url: '/job_description',
            icon: 'IconFileDescription',
            breadcrumbs: false
        },
        {
            id: 'masters.view_tblcandidateprofile',
            title: 'Candidate',
            type: 'item',
            url: '/candidate_profile',
            icon: 'IconBriefcase',
            breadcrumbs: false
        },
    ]
};
